import { createReducer } from 'redux-act';
import actions from '../actions/holidaysActions';

const initialState = {
  createHolidayPending: false,
  createHolidayRes: null,
  createHolidayError: null,

  getHolidayPending: false,
  getHolidayRes: null,
  getHolidayError: null,

  updateHolidayPending: false,
  updateHolidayRes: null,
  updateHolidayError: null,

  deleteHolidayPending: false,
  deleteHolidayRes: null,
  deleteHolidayError: null,

  sampleDownloadPending: false,
  sampleDownloadRes: null,
  sampleDownloadError: null,

  uploadHolidayPending: false,
  uploadHolidayRes: null,
  uploadHolidayError: null,
};
// create holiday by admin
const handleCreateHolidayRequest = state => {
  return {
    ...state,
    ...{
      createHolidayPending: true,
      createHolidayRes: null,
      createHolidayError: null,
    },
  };
};
const handleCreateHolidaySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      createHolidayPending: false,
      createHolidayRes: payload,
      createHolidayError: null,
    },
  };
};
const handleCreateHolidayError = (state, payload) => ({
  ...state,
  ...{
    createHolidayPending: false,
    createHolidayRes: null,
    createHolidayError: payload,
  },
});

// get holiday
const handleGetHolidayRequest = state => {
  return {
    ...state,
    ...{
      getHolidayPending: true,
      getHolidayRes: null,
      getHolidayError: null,
    },
  };
};
const handleGetHolidaySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getHolidayPending: false,
      getHolidayRes: payload,
      getHolidayError: null,
    },
  };
};
const handleGetHolidayError = (state, payload) => ({
  ...state,
  ...{
    getHolidayPending: false,
    getHolidayRes: null,
    getHolidayError: payload,
  },
});

// update holiday
const handleUpdateHolidayRequest = state => {
  return {
    ...state,
    ...{
      updateHolidayPending: true,
      updateHolidayRes: null,
      updateHolidayError: null,
    },
  };
};
const handleUpdateHolidaySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateHolidayPending: false,
      updateHolidayRes: payload,
      updateHolidayError: null,
    },
  };
};
const handleUpdateHolidayError = (state, payload) => ({
  ...state,
  ...{
    updateHolidayPending: false,
    updateHolidayRes: null,
    updateHolidayError: payload,
  },
});

// delete holiday
const handleDeleteHolidayRequest = state => {
  return {
    ...state,
    ...{
      deleteHolidayPending: true,
      deleteHolidayRes: null,
      deleteHolidayError: null,
    },
  };
};
const handleDeleteHolidaySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      deleteHolidayPending: false,
      deleteHolidayRes: payload,
      deleteHolidayError: null,
    },
  };
};
const handleDeleteHolidayError = (state, payload) => ({
  ...state,
  ...{
    deleteHolidayPending: false,
    deleteHolidayRes: null,
    deleteHolidayError: payload,
  },
});

// Sample Download by admin
const handleSampleDownloadRequest = state => {
  return {
    ...state,
    ...{
      sampleDownloadPending: true,
  sampleDownloadRes: null,
  sampleDownloadError: null,
    },
  };
};
const handleSampleDownloadSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      sampleDownloadPending: false,
  sampleDownloadRes: payload,
  sampleDownloadError: null,
    },
  };
};
const handleSampleDownloadError = (state, payload) => ({
  ...state,
  ...{
    sampleDownloadPending: false,
  sampleDownloadRes: null,
  sampleDownloadError: payload,
  },
});

// Upload Holiday by admin
const handleUploadHoliDayRequest = state => {
  return {
    ...state,
    ...{
      uploadHolidayPending: true,
  uploadHolidayRes: null,
  uploadHolidayError: null,
    },
  };
};
const handleUploadHoliDaySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      uploadHolidayPending: false,
  uploadHolidayRes: payload,
  uploadHolidayError: null,
    },
  };
};
const handleUploadHoliDayError = (state, payload) => ({
  ...state,
  ...{
    uploadHolidayPending: false,
    uploadHolidayRes: null,
    uploadHolidayError: payload,
  },
});

// clear existing data
const handleClearHolidayStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_CREATE_HOLIDAY_STORE':
      return {
        ...state,
        ...{
          createHolidayPending: false,
          createHolidayRes: null,
          createHolidayError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_HOLIDAY_STORE':
      return {
        ...state,
        ...{
          deleteHolidayPending: false,
          deleteHolidayRes: null,
          deleteHolidaySuccess: null,
        },
      };
      case 'HANDLE_CLEAR_UPDATE_HOLIDAY_STORE':
      return {
        ...state,
        ...{
          updateHolidayPending: false,
          updateHolidayRes: null,
          updateHolidaySuccess: null,
        },
      };
      case 'HANDLE_CLEAR_SAMPLE_STORE':
      return {
        ...state,
        ...{
          sampleDownloadPending: false,
          sampleDownloadRes: null,
          sampleDownloadError: null,
        },
      };
      case 'HANDLE_CLEAR_UPLOAD_HOLIDAY_STORE':
        return {
          ...state,
          ...{
            uploadHolidayPending: false,
            uploadHolidayRes: null,
            uploadHolidayError: null,
          },
        };
    default:
      return state;
  }
};

export default createReducer(
  {
    [actions.createHolidayRequest]: handleCreateHolidayRequest,
    [actions.createHolidaySuccess]: handleCreateHolidaySuccess,
    [actions.createHolidayError]: handleCreateHolidayError,

    [actions.getHolidayRequest]: handleGetHolidayRequest,
    [actions.getHolidaySuccess]: handleGetHolidaySuccess,
    [actions.getHolidayError]: handleGetHolidayError,

    [actions.updateHolidayRequest]: handleUpdateHolidayRequest,
    [actions.updateHolidaySuccess]: handleUpdateHolidaySuccess,
    [actions.updateHolidayError]: handleUpdateHolidayError,

    [actions.deleteHolidayRequest]: handleDeleteHolidayRequest,
    [actions.deleteHolidaySuccess]: handleDeleteHolidaySuccess,
    [actions.deleteHolidayError]: handleDeleteHolidayError,

    [actions.sampleDownloadRequest]: handleSampleDownloadRequest,
    [actions.sampleDownloadSuccess]: handleSampleDownloadSuccess,
    [actions.sampleDownloadError]: handleSampleDownloadError,

    [actions.uploadHolidayRequest]: handleUploadHoliDayRequest,
    [actions.uploadHolidaySuccess]: handleUploadHoliDaySuccess,
    [actions.uploadHolidayError]: handleUploadHoliDayError,


    [actions.handleClearHolidayStore]: handleClearHolidayStore,

  },
  initialState,
);
